/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求4（任务单 DEV-120352）；
 *          视觉基准 docs/旅游落地页/cj商旅-01.html 第 2172~2265 行（.cjbt-about-v2）。
 * 注意事项：
 * 1. 纯静态展示区块，原型无对应脚本；左文案（描述首词 CJ Business Travel 加粗）+ 右主图/图注/小图/装饰。
 * 2. 描述段原型为 `<strong>CJ Business Travel</strong> creates personalized…`，i18n 拆成 strong 与余文两个 key，
 *    渲染时补一个空格，避免 JSX 折行吞空白导致两段粘连。
 */
import React from 'react';

export default function About(props) {
  var ABOUT = props.data;

  return (
    <section className="cjbt-about-v2" id="cjbt-about">
      <div className="cjbt-about-v2__container">

        {/* LEFT CONTENT */}
        <div className="cjbt-about-v2__content">

          <div className="cjbt-about-v2__eyebrow">{ABOUT.eyebrow}</div>

          <h2 className="cjbt-about-v2__title">
            {ABOUT.title}{' '}
            <span className="cjbt-about-v2__title-accent">{ABOUT.titleAccent}</span>
          </h2>

          <p className="cjbt-about-v2__description">
            <strong>{ABOUT.descriptionStrong}</strong>{' '}
            {ABOUT.description}
          </p>

          <div className="cjbt-about-v2__statement">
            <span className="cjbt-about-v2__statement-label">{ABOUT.statementLabel}</span>
            <strong>{ABOUT.statementStrong}</strong>
            <p>{ABOUT.statementText}</p>
          </div>

          <div className="cjbt-about-v2__values">
            {ABOUT.values.map(function (value) {
              return (
                <div className="cjbt-about-v2__value" key={value.number}>
                  <span className="cjbt-about-v2__value-number">{value.number}</span>
                  <strong>{value.text}</strong>
                </div>
              );
            })}
          </div>

        </div>

        {/* RIGHT VISUAL */}
        <div className="cjbt-about-v2__visual">

          <div className="cjbt-about-v2__main-image">
            <img src={ABOUT.mainImage} alt={ABOUT.mainImageAlt} loading="lazy" />
          </div>

          <div className="cjbt-about-v2__image-caption">
            <span>
              <strong>{ABOUT.captionTitle}</strong>
              <small>{ABOUT.captionText}</small>
            </span>
            <span className="cjbt-about-v2__image-number">{ABOUT.captionMark}</span>
          </div>

          <div className="cjbt-about-v2__small-image">
            <img src={ABOUT.smallImage} alt={ABOUT.smallImageAlt} loading="lazy" />
          </div>

          <span className="cjbt-about-v2__decor cjbt-about-v2__decor--orange"></span>
          <span className="cjbt-about-v2__decor cjbt-about-v2__decor--line"></span>

        </div>

      </div>
    </section>
  );
}
